import { createFileRoute, Outlet, Link, useLocation } from "@tanstack/react-router";
import { TabbedLayout } from "@charphq/ui/components/layout";
import type { Tab } from "@charphq/ui/components/layout";
import { Layers, Radio, Wifi } from "lucide-react";

export const Route = createFileRoute("/devices")({
  component: DevicesLayoutComponent,
});

const deviceTabs: Tab[] = [
  {
    value: "all",
    label: "All Devices",
    icon: <Layers className="h-4 w-4" />,
    href: "/devices",
  },
  {
    value: "xtel",
    label: "Xtel",
    icon: <Radio className="h-4 w-4" />,
    href: "/devices/xtel",
  },
  {
    value: "lorawan",
    label: "LoRaWAN",
    icon: <Wifi className="h-4 w-4" />,
    href: "/devices/lorawan",
  },
];

function DevicesLayoutComponent() {
  const location = useLocation();
  const pathname = location.pathname;

  const activeTab =
    pathname === "/devices/xtel" ? "xtel" : pathname === "/devices/lorawan" ? "lorawan" : "all";

  return (
    <TabbedLayout
      title="Devices"
      description="Manage and monitor all your devices across different platforms"
      activeTab={activeTab}
      tabs={deviceTabs}
      Link={Link}
      breadcrumbs={[{ label: "Home", href: "/" }, { label: "Devices" }]}
    >
      <Outlet />
    </TabbedLayout>
  );
}
